import type { ConceptDef } from '../types';

export const tactEmotions: ConceptDef = {
  kind: 'supervisorScored',
  id: 'tact-emotions',
  label: 'Expressive Emotions',
  category: 'Expressive',
  description: 'Show an emotion; learner names it. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: '😀', hint: 'happy' },
      { prompt: '😢', hint: 'sad' },
      { prompt: '😡', hint: 'angry' },
      { prompt: '😨', hint: 'scared' },
      { prompt: '😲', hint: 'surprised' },
      { prompt: '🥳', hint: 'proud' },
    ],
  },
};
